module.exports = __webpack_public_path__ + "img/arrow-right-icon.7a06368b.svg";